import { chartGlobalLabelDefaults } from '@/constants/chart-global-styles.constants'
export default {
  id: 'nodata-label-plugin',
  defaults: {
    style: chartGlobalLabelDefaults.style,
    text: chartGlobalLabelDefaults.text
  },
  afterDraw: function (chart) {
    let nodata = true
    for (let idx in chart.data.datasets) {
      if (chart.data.datasets[idx].data.length > 0) {
        nodata = false
        break
      }
    }
    if (nodata) {
      // No data is present
      let ctx = chart.chart.ctx
      let width = chart.chart.width
      let height = chart.chart.height
      let title = ''
      if (chart.options.title.display === true) {
        title = chart.options.title.text
      }
      chart.clear()

      let styles = _.clone(this.defaults.style)

      if (chart.options.plugins['nodata-label-plugin']) {
        _.merge(styles, chart.options.plugins['nodata-label-plugin'].style)
      }
      ctx.save()
      ctx.canvas.style.borderRight = `1px solid ${styles.borderColor}`
      ctx.textBaseline = styles.textBaseline
      ctx.textAlign = styles.textAlign
      ctx.font = `${styles.fontStyle} ${styles.fontFamily}`

      if (!_.isEmpty(title)) {
        ctx.fillText(title, width / 2, 20)
      }

      ctx.fillText(this.defaults.text.nodata, width / 2, height / 2)
      ctx.restore()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/chart/plugins/nodata-label.plugin.js